import { styled } from "@mui/material/styles";
import Backdrop from "@mui/material/Backdrop";

const BackdropWhite = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.tooltip + 1,
  color: "#fff",
}));

export default BackdropWhite;
